export const configurationFormatEnum = {
  DEFAULT: 'DEFAULT',
  ELVACO_21XX: 'ELVACO_21XX',
} as const

export type ConfigurationFormatEnum = (typeof configurationFormatEnum)[keyof typeof configurationFormatEnum]

export type ConfigurationFormat = ConfigurationFormatEnum